
const QueryBuilder = (queryObj = false) => {
    if (!queryObj) {
        return '';
    }

    let queryString = '?';
    let queryPairs = [];
    for (let [key, value] of Object.entries(queryObj)) {
        queryPairs.push(`${encodeURIComponent(key)}=${encodeURIComponent(value)}`);
    }
    queryString += queryPairs.join('&');
    return queryString;
};

export default QueryBuilder;